import { render, staticRenderFns } from "./detailMangaView.vue?vue&type=template&id=61989090&scoped=true&"
import script from "./detailMangaView?vue&type=script&lang=js&"
export * from "./detailMangaView?vue&type=script&lang=js&"
import style0 from "./detailMangaView.scss?vue&type=style&index=0&id=61989090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61989090",
  null
  
)

export default component.exports